import { get, post } from '../utils/axios/https';

export default {
    test: () => {},
    validateProduct: (body) => post(`api/consumo/validar/`, body),
    registerProducts: (body) => post(`api/consumo/registrar/`, body),
    getRegisterTransactions: () => get(`api/transacciones/`),
    getAllProductsById: (id) => get(`api/paciente/${id}/producto/`),
};
